import React from 'react';
import { Link } from 'react-router-dom';

const Mixers = () => {
  return (
    <div>
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link> / 
            <Link to="/services" className="hover:text-accent"> Services</Link> / 
            <span className="text-gray-900"> Mixers</span>
          </div>
        </div>
      </div>

      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Mixers</h1>
          <p className="text-xl text-gray-300">Industrial Mixing Solutions for Uniform Blending</p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-4 text-accent">Twin Shaft Mixer</h3>
              <p className="text-gray-700">High-capacity mixer with two parallel shafts for efficient blending of powders and granules. Ideal for food processing and pharmaceutical applications.</p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-4 text-accent">Paddle Mixer</h3>
              <p className="text-gray-700">Versatile mixer with paddle-shaped agitators for thorough mixing of dry and wet materials. Suitable for various industrial applications.</p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-4 text-accent">Turbo Blender</h3>
              <p className="text-gray-700">High-speed blending solution for rapid homogenization of ingredients. Perfect for powder processing and instant mixing requirements.</p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-4 text-accent">Sigma Mixer</h3>
              <p className="text-gray-700">Heavy-duty mixer with sigma-shaped blades for high-viscosity materials and dough-like substances. Widely used in food and chemical industries.</p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-4 text-accent">Ribbon Blender</h3>
              <p className="text-gray-700">Efficient ribbon-type agitator providing gentle yet thorough mixing action. Ideal for dry powder blending and fragile materials.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Need Custom Mixer Solutions?</h2>
          <Link to="/contact" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
            Request a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Mixers;
